<div class="templates-app" ui-view></div>
